import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPage = () => (
  <div className="min-h-screen pt-24 pb-20" data-testid="privacy-page">
    <div className="bg-[#000000] py-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-bold text-white font-['Playfair_Display']">Politique de Confidentialité</h1>
      </div>
    </div>
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 prose prose-lg max-w-none">
      <h2 className="text-2xl font-bold font-['Playfair_Display'] mb-4">1. Collecte des données personnelles</h2>
      <p className="text-[#4B5563] mb-6 leading-relaxed">
        Dans le cadre de la réservation de sorties de pêche, CALVI FISHING collecte les données personnelles suivantes :<br />
        - Nom et prénom de chaque participant<br />
        - Âge des participants<br />
        - Numéro de téléphone<br />
        - Adresse email<br /><br />
        Ces données sont nécessaires à la gestion des réservations, à la sécurité des passagers et à la communication relative aux sorties.
      </p>

      <h2 className="text-2xl font-bold font-['Playfair_Display'] mb-4">2. Finalité du traitement</h2>
      <p className="text-[#4B5563] mb-6 leading-relaxed">
        Les données collectées sont utilisées pour :<br />
        - La gestion et le suivi des réservations<br />
        - L'envoi de confirmations de réservation<br />
        - La communication d'informations relatives aux sorties (modifications, annulations, conditions météo)<br />
        - L'établissement de la liste des passagers conformément à la réglementation maritime<br />
        - L'amélioration de nos services
      </p>

      <h2 className="text-2xl font-bold font-['Playfair_Display'] mb-4">3. Base légale</h2>
      <p className="text-[#4B5563] mb-6 leading-relaxed">
        Le traitement des données personnelles est fondé sur l'exécution du contrat de prestation de service (réservation d'une sortie de pêche) et, le cas échéant, sur le consentement du client.
      </p>

      <h2 className="text-2xl font-bold font-['Playfair_Display'] mb-4">4. Durée de conservation</h2>
      <p className="text-[#4B5563] mb-6 leading-relaxed">
        Les données personnelles sont conservées pendant la durée nécessaire à la gestion de la relation commerciale et pendant les durées légales de conservation applicables, soit 3 ans à compter de la dernière interaction.
      </p>

      <h2 className="text-2xl font-bold font-['Playfair_Display'] mb-4">5. Partage des données</h2>
      <p className="text-[#4B5563] mb-6 leading-relaxed">
        Les données personnelles ne sont pas vendues ni cédées à des tiers. Elles peuvent être partagées avec :<br />
        - Square (prestataire de paiement sécurisé) pour le traitement des paiements<br />
        - Les autorités maritimes en cas de contrôle réglementaire<br />
        - Nos prestataires techniques dans le cadre strict de la gestion du site
      </p>

      <h2 className="text-2xl font-bold font-['Playfair_Display'] mb-4">6. Sécurité des données</h2>
      <p className="text-[#4B5563] mb-6 leading-relaxed">
        CALVI FISHING met en œuvre toutes les mesures techniques et organisationnelles appropriées pour protéger les données personnelles contre tout accès, modification, divulgation ou destruction non autorisé. Les paiements sont sécurisés par la technologie SSL via Square.
      </p>

      <h2 className="text-2xl font-bold font-['Playfair_Display'] mb-4">7. Droits des utilisateurs</h2>
      <p className="text-[#4B5563] mb-6 leading-relaxed">
        Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez des droits suivants :<br />
        - <strong>Droit d'accès</strong> : obtenir la confirmation du traitement de vos données<br />
        - <strong>Droit de rectification</strong> : corriger des données inexactes<br />
        - <strong>Droit à l'effacement</strong> : demander la suppression de vos données<br />
        - <strong>Droit d'opposition</strong> : vous opposer au traitement de vos données<br />
        - <strong>Droit à la portabilité</strong> : recevoir vos données dans un format structuré<br /><br />
        Pour exercer ces droits, contactez-nous à : <strong>contact@calvi-fishing.com</strong>
      </p>

      <h2 className="text-2xl font-bold font-['Playfair_Display'] mb-4">8. Contact</h2>
      <p className="text-[#4B5563] mb-6 leading-relaxed">
        Pour toute question relative à la protection de vos données personnelles :<br />
        CALVI FISHING<br />
        Port de Plaisance, 20260 Calvi, Corse<br />
        Email : contact@calvi-fishing.com<br />
        Téléphone : 06 44 38 34 06
      </p>

      <div className="flex gap-4 mt-10 pt-8 border-t border-[#E2E8F0]">
        <Link to="/legal" className="text-[#b7ede0] hover:underline font-medium">Mentions légales</Link>
        <Link to="/cgv" className="text-[#b7ede0] hover:underline font-medium">CGV</Link>
      </div>
    </div>
  </div>
);

export default PrivacyPage;
